import { render, staticRenderFns } from "./CollectionCallReport.vue?vue&type=template&id=cb0b8ee0&scoped=true&"
import script from "./CollectionCallReport.vue?vue&type=script&lang=js&"
export * from "./CollectionCallReport.vue?vue&type=script&lang=js&"
import style0 from "./CollectionCallReport.vue?vue&type=style&index=0&id=cb0b8ee0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb0b8ee0",
  null
  
)

export default component.exports